<template>
  <figure class="shareProduct">
    <div class="shareCard" ref="shareCard" v-if="shareData">
      <div class="shareCard-left">
        <div class="shareCard-name">{{ shareData.name }}</div>
        <div class="shareCard-price">
          <span class="priceBoxUnit">$</span>
          <span class="priceBoxNum">
            {{ Math.round(shareData.price * 100) / 100 }}
          </span>
        </div>
      </div>
      <div class="shareCard-right">
        <img class="shareLogo" src="~assets/img/home/logo.png" />
      </div>
      <div class="shareCard-image">
        <van-image class="image" :src="image" v-if="image">
          <template v-slot:error>
            <img class="image-error" src="~assets/img/other/empty.gif" />
          </template>
        </van-image>
        <van-loading type="spinner" color="#ffffff" v-else />
      </div>
      <div class="shareCard-footer">
        <img class="shareQrcode" ref="qrcode" :src="qrCode" v-if="qrCode" />
      </div>
    </div>
    <div class="downloadBox" @click="download">
      <div class="button">{{ $t.meta.saveToAlbum }}</div>
    </div>
    <div class="downloadBox" @click="shareGoods">
      <div class="button">{{ $t.meta.shareLink }}</div>
    </div>
  </figure>
</template>
<script>
import Vue from "vue";
import { Loading, Image } from "vant";
Vue.use(Loading).use(Image);

import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import QRCode from "qrcode";
import html2canvas from "html2canvas";

export default {
  name: "shareProduct",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      shareData: null,
      qrCode: "",
      image: "",
    };
  },
  mounted() {
    var data = JSON.parse(localStorage.getItem("shareProduct"));
    this.shareData = data;
    this.getQrcodeDataUrl();
    this.toBase64(this.imgUrlAgency(this.imgUrlFilter(this.shareData.image))).then(
      (base64) => {
        this.image = base64;
      }
    );
  },
  methods: {
    async toBase64(url) {
      const res = await fetch(url);
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    getQrcodeDataUrl() {
      QRCode.toDataURL(this.shareData.shareUrl)
        .then((url) => {
          this.qrCode = url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    shareGoods() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.shareGoods, this.shareData);
    },
    download() {
      let e = this.$refs.shareCard;
      if (this.isApp) {
        html2canvas(e, {
          allowTaint: true,
          useCORS: true,
          tainttest: true,
          backgroundColor: null,
        }).then((canvas) => {
          Base64Image.save(
            canvas.toDataURL(),
            () => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: this.$t.saveSuccess,
                type: "success",
              });
            },
            () => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: this.$t.saveFail,
                type: "error",
              });
            }
          );
        });
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
          element: e,
          successText: this.$t.saveSuccess,
          failText: this.$t.saveFail,
        });
      }
    },
    imgUrlAgency(value) {
      return `https://images.weserv.nl/?url=${encodeURIComponent(value)}`;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
  },
};
</script>
<style lang="scss" scoped>
.shareProduct {
  width: 100%;
  display: inline-block;
  margin: 0 auto;
  position: relative;
  .shareCard {
    margin: 20px;
    padding: 20px;
    background: -webkit-gradient(linear, left top, right top, from(#71d283), to(#01aaa3));
    .shareCard-left {
      width: 70%;
      display: inline-block;
      vertical-align: middle;
      text-align: left;
      .shareCard-name {
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 10px;
      }
      .shareCard-price {
        .priceBoxUnit {
          color: #ffffff;
          font-size: 14px;
          font-weight: bold;
        }
        .priceBoxNum {
          color: #ffffff;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .shareCard-right {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
      text-align: right;
      .shareLogo {
        width: 50px;
        height: 50px;
      }
    }
    .shareCard-image {
      text-align: center;
      margin-top: 20px;
      .image {
        width: 50%;
        height: 100%;
        object-fit: cover;
        .van-image__error {
          position: relative;
        }
      }
      .image-error {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .van-loading {
        margin: auto;
        line-height: 250px;
      }
    }
    .shareCard-footer {
      text-align: left;
      margin-top: 20px;
      .shareQrcode {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        width: 50px;
        height: 50px;
      }
    }
  }
  .downloadBox {
    width: 80%;
    margin: 5% auto;
    text-align: center;
    .button {
      position: relative;
      width: 100%;
      margin: 0 auto;
      border-radius: 3rem;
      padding: 0.8rem 0;
      text-align: center;
      background: linear-gradient(left, #25b9ff, #0090e6);
      color: #ffffff;
      font-size: 1rem;
      line-height: 1;
    }
    .text {
      color: #0090e6;
      font-weight: bold;
    }
  }
}
</style>
